/** Default welcome letter (text). Placeholders are merged at send time. */
export const DEFAULT_WELCOME_SUBJECT_TEMPLATE = "Welcome to {{company_name}}";

export const DEFAULT_WELCOME_BODY_TEMPLATE = `WELCOME TO
{{company_name}}

Hello {{recipient_name}},

We'd like to personally welcome you to the team. We're very excited to have you onboard and are looking forward to a great working relationship during your time with us here.

Your IT Support team is available to help you with anything technical. Please see below for details about your computer login and company email.

Email Info:
Webmail: https://outlook.office365.com
Email: {{user_email}}
PC Username: {{pc_username}}
Password: {{temporary_password}}

If you have a new PC, you may need to activate your computer by adding your mobile phone number during login and then add a 6-digit PIN and fingerprint (if applicable).

If you have any questions or need support, please contact our team.

Thank you,
IT Support Team`;
